export default "__VITE_ASSET__dNa_6z9N__"